import { render, staticRenderFns } from "./InboxChannels.vue?vue&type=template&id=83562300&"
import script from "./InboxChannels.vue?vue&type=script&lang=js&"
export * from "./InboxChannels.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('83562300')) {
      api.createRecord('83562300', component.options)
    } else {
      api.reload('83562300', component.options)
    }
    module.hot.accept("./InboxChannels.vue?vue&type=template&id=83562300&", function () {
      api.rerender('83562300', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/settings/inbox/InboxChannels.vue"
export default component.exports